"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-lines-per-function */
const summithill_models_1 = require("@clearsummit/summithill-models");
const axios_1 = __importDefault(require("axios"));
const auth_1 = require("@/helpers/auth");
const config_1 = __importDefault(require("../config"));
const REFRESH_TOKEN = '/refresh/';
class ApiService {
    constructor() {
        this.setAuthHeader = (authToken) => {
            var _a;
            this.authToken = authToken;
            if (authToken && authToken.access && ((_a = authToken.access) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.axios.defaults.headers.Authorization = `Bearer ${authToken.access}`;
            }
        };
        this.get = ({ url, payload, responseType, }) => this.axios.get(url, { apiResponseType: responseType, params: payload });
        // @ts-ignore
        this.post = ({ url, payload, responseType }) => this.axios.post(url, payload, { apiResponseType: responseType });
        // @ts-ignore
        this.put = ({ url, payload, responseType }) => this.axios.put(url, payload, { apiResponseType: responseType });
        // @ts-ignore
        this.patch = ({ url, payload, responseType }) => this.axios.patch(url, payload, { apiResponseType: responseType });
        // @ts-ignore
        this.delete = ({ url, payload, responseType }) => this.axios.delete(url, payload, { apiResponseType: responseType });
        this.refreshing = false;
        const { API_URL, showsAPIBodies } = config_1.default;
        const data = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            baseURL: API_URL || '',
        };
        this.axios = axios_1.default.create(data);
        let start;
        // @ts-ignore
        this.axios.interceptors.request.use((configuration) => {
            start = Date.now();
            if (showsAPIBodies) {
                const method = (configuration === null || configuration === void 0 ? void 0 : configuration.method) || '';
                console.groupCollapsed(`%c API Request => ${method.toUpperCase()} ${configuration.url}`, `color: lightslategrey`);
                console.log('timestamp', new Date(Date.now()).toString());
                console.log('configuration', configuration);
                console.groupEnd();
            }
            return configuration;
        });
        this.axios.interceptors.response.use((response) => {
            var _a;
            if (showsAPIBodies) {
                const method = ((_a = response === null || response === void 0 ? void 0 : response.config) === null || _a === void 0 ? void 0 : _a.method) || '';
                console.groupCollapsed(`%c API Response => ${method.toUpperCase()} ${response === null || response === void 0 ? void 0 : response.config.url}`, `color: forestgreen`);
                console.log('timestamp', new Date(Date.now()).toString());
                console.log('duration', `${Date.now() - start}ms`);
                console.log('response', response);
                console.groupEnd();
            }
            // @ts-ignore
            const { apiResponseType } = response.config;
            if (apiResponseType) {
                response.data = summithill_models_1.modelMapper(apiResponseType, response.data);
            }
            return response;
        }, (error) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g;
            const method = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.method) || '';
            if (!this.refreshing && (((_c = error.response) === null || _c === void 0 ? void 0 : _c.status) === 401 || ((_d = error.response) === null || _d === void 0 ? void 0 : _d.status) === 403)) {
                // Try to refresh the token and make the request again
                console.log(`%c API Refreshing => ${method.toUpperCase()} ${((_e = error.response) === null || _e === void 0 ? void 0 : _e.config.url) || ''}`, `color: gold`);
                try {
                    this.refreshing = true;
                    const refreshResponse = yield this.axios.post(REFRESH_TOKEN, { refresh: (_f = this.authToken) === null || _f === void 0 ? void 0 : _f.refresh });
                    const tokens = refreshResponse.data;
                    this.authToken = tokens;
                    auth_1.setAuth(tokens);
                    this.setAuthHeader(tokens);
                    const response = yield this.axios.request(error.config);
                    this.refreshing = false;
                    return Promise.resolve(response);
                }
                catch (e) {
                    this.refreshing = false;
                }
            }
            console.groupCollapsed(`%c API Error => ${method.toUpperCase()} ${((_g = error.response) === null || _g === void 0 ? void 0 : _g.config.url) || ''}`, `color: firebrick`);
            console.log('timestamp', new Date(Date.now()).toString());
            console.log('duration', `${Date.now() - start}ms`);
            console.log('error', { error });
            console.groupEnd();
            return Promise.reject(error);
        }));
    }
}
exports.default = new ApiService();
